<template>
    <div>
        <el-divider></el-divider>
        <div style="display:flex;flex-direction:row;margin-top: 1%;margin-bottom:1%">
            <el-button-group>
                <el-button type="primary" @click="add4">{{ $t("lang.增加") }}</el-button>
                <el-button type="info" @click="edit4">{{ $t("lang.编辑") }}</el-button>
                <el-button type="danger" @click="del4">{{ $t("lang.删除") }}</el-button>
            </el-button-group>
        </div>
        <ve-table :columns="columns4" ref="table4" borderY style="margin-top:10px;" :table-data="tableData4" row-key-field-name="id" :cell-style-option="cellStyleOption4"></ve-table>
        <ve-pagination :total="searchObj4.total" :pageIndex="searchObj4.pageIndex" :layout="['total', 'prev', 'next', 'jumper']" style="margin-top:10px;" @on-page-number-change="load4"></ve-pagination>

        <el-dialog :visible.sync="visible4" :close-on-click-modal="false" width="40%" :show-close="false">
            <template #title><i class="iconfont icon-changtiao-copy" style="color:#409EFF"></i>{{ $t("lang.水泵绑定") }}</template>
            <el-form :model="model4" ref="form4" label-width="150px" :rules="rules4">
                <el-form-item :label="$t('lang.名称')" prop="name">
                    <el-input v-model="model4.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.通道')" required>
                    <el-col :span="16">
                        <el-form-item prop="serialNumber">
                            <el-select v-model="model4.serialNumber" style="width:100%" @change="tab4HandleChange">
                                <el-option v-for="(item, index) in myCompanyDevice" :key="index" :label="item.serialNumber + '(' + item.remark + ')'" :value="item.serialNumber">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item prop="passageway">
                            <el-select v-model="model4.passageway">
                                <el-option v-for="(item, index) in tab4TongDaoCount" :key="index" :value="'T' + (index + 1)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item :label="$t('lang.温度')" prop="temperature">
                    <el-input v-model.number="model4.temperature" type="number"><template #append>℃</template></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.开关')" required>
                    <el-col :span="16">
                        <el-form-item prop="imei">
                            <el-input v-model="model4.imei" :placeholder="$t('lang.请输入开关imei')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item prop="channel">
                            <el-select v-model="model4.channel">
                                <el-option value="1" :label="$t('lang.继电器1')"></el-option>
                                <el-option value="2" :label="$t('lang.继电器2')"></el-option>
                                <el-option value="3" :label="$t('lang.继电器3')"></el-option>
                                <el-option value="4" :label="$t('lang.继电器4')"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item :label="$t('lang.备注')">
                    <el-input v-model="model4.remark"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div style="display:flex;flex-direction:row-reverse">
                    <el-button type="primary" style="margin-left:10px;" @click="submit4">{{ $t("lang.保存") }}</el-button>
                    <el-button type="info" @click="visible4 = false">{{ $t("lang.取消") }}</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog :visible.sync="visible4_detail" :close-on-click-modal="false" width="25%" :show-close="false">
            <template #title><i class="iconfont icon-changtiao-copy" style="color:#409EFF"></i>{{ $t("lang.开关明细") }}</template>
            <ve-table :columns="columns4_detail" :table-data="tableData4_detail" maxHeight="500px" borderY />
            <template #footer>
                <div style="display:flex;flex-direction:row-reverse">
                    <el-button type="info" @click="visible4_detail = false">{{ $t("lang.关闭") }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";
Vue.use(VueEasytable);

export default {
    data() {
        let that = this;
        return {
            myCompanyDevice: [],
            tab4TongDaoCount: 8,
            visible4: false,
            searchObj4: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            tableData4: [],
            model4: {},
            cellStyleOption4: {
                bodyCellClass: ({ column }) => {
                    if (column.field == "tongDao") {
                        return "bgRed-WXCW03BJGL";
                    }
                    else if (column.field == "temperature") {
                        return "bgRed1-WXCW03BJGL";
                    }
                    else if (column.field == "imei" || column.field == "channel") {
                        return "bgBlue-WXCW03BJGL";
                    }
                },
            },
            rules4: {
                name: [{ required: true, message: that.$t("lang.请输入名称"), trigger: "change" }],
                serialNumber: [{ required: true, message: that.$t("lang.请选择设备"), trigger: "change" }],
                passageway: [{ required: true, message: that.$t("lang.请选择通道"), trigger: "change" }],
                temperature: [
                    { required: true, message: that.$t("lang.请输入温度"), trigger: "change" },
                    { type: "number", message: that.$t("lang.必须为数字值") },
                ],
                imei: [{ required: true, message: that.$t("lang.请输入开关imei"), trigger: "change" },
                { min: 15, max: 15, message: that.$t("lang.长度15个字符"), trigger: 'blur' }],
                channel: [{ required: true, message: that.$t("lang.请选择继电器"), trigger: "change" }],
            },
            columns4: [
                { field: "name", key: "name", title: that.$t("lang.名称") },
                {
                    field: "tongDao",
                    key: "tongDao",
                    title: that.$t("lang.通道"),
                    renderBodyCell: ({ row }) => {
                        return row.serialNumber + "(" + row.passageway + ")";
                    },
                },
                { field: "temperature", key: "temperature", title: that.$t("lang.温度") },
                { field: "imei", key: "imei", title: that.$t("lang.开关imei") },
                { field: "channel", key: "channel", title: that.$t("lang.继电器") },
                { field: "remark", key: "remark", title: that.$t("lang.备注") },
                { field: "createTime", key: "createTime", title: that.$t("lang.创建时间") },
                {
                    field: "",
                    key: "e",
                    title: that.$t("lang.操作"),
                    renderBodyCell: ({ row }) => {
                        return (
                            <el-button type="primary" size="mini" on-click={() => that.loadDetail4(row)}>{that.$t('lang.明细')}</el-button>
                        );
                    },
                },
            ],
            visible4_detail: false,
            columns4_detail: [
                { field: "createTime", key: "createTime", title: that.$t("lang.时间") },
                { field: "msg", key: "msg", title: "msg" },
            ],
            tableData4_detail: [],
        };
    },
    methods: {
        tab4HandleChange(v) {
            let that = this;
            let selectSerialNumberObject = that.myCompanyDevice.find((ele) => { return ele.serialNumber == v; });
            if (selectSerialNumberObject.deviceType == "WXCW80") {
                that.tab4TongDaoCount = 4;
            } else {
                that.tab4TongDaoCount = 8;
            }
        },
        add4() {
            let that = this;
            that.visible4 = true;
            that.model4 = { baoJingJianGe: 30 };
            if (that.$refs["form4"]) {
                that.$refs["form4"].resetFields();
            }
        },
        edit4() {
            let that = this;
            if (that.$refs["table4"].highlightRowKey) {
                that.axios
                    .post("YinErDa/Get_One_WXCW03_ShuiBeng", {
                        onlyInt: that.$refs["table4"].highlightRowKey,
                    })
                    .then((response) => {
                        that.model4 = response.data.data;
                        that.visible4 = true;
                        let tmpObject = that.myCompanyDevice.find((ele) => { return ele.serialNumber == that.model4.serialNumber; });
                        if (tmpObject.deviceType == "WXCW80") {
                            that.tab4TongDaoCount = 4;
                        }
                        else {
                            that.tab4TongDaoCount = 8;
                        }
                    });
            } else {
                that.$message({ type: "error", message: that.$t("lang.请选择一条记录") });
            }
        },
        del4() {
            let that = this;
            if (that.$refs["table4"].highlightRowKey) {
                that.$confirm(that.$t("lang.确定要删除吗"))
                    .then(function () {
                        that.axios
                            .post("YinErDa/Del_WXCW03_ShuiBeng", {
                                onlyInt: that.$refs["table4"].highlightRowKey,
                            })
                            .then(function () {
                                that.$refs["table4"].highlightRowKey = "";
                                that.$message({ type: "success", message: that.$t("lang.删除成功") });
                                that.load4();
                            });
                    })
                    .catch(() => { });
            } else {
                that.$message({ type: "error", message: that.$t("lang.请选择一条记录") });
            }
        },
        submit4() {
            let that = this;
            that.$refs["form4"].validate((valid) => {
                if (valid) {
                    that.axios.post("YinErDa/Save_WXCW03_ShuiBeng", that.model4).then((response) => {
                        if (response.data.code == 101) {
                            that.visible4 = false;
                            that.$message({ type: "success", message: that.$t("lang.保存成功") });
                            that.load4();
                        }
                    });
                }
            });
        },
        load4(v) {
            let that = this;
            if (v) {
                that.searchObj4.pageIndex = v;
            }
            that.axios.post("YinErDa/Get_WXCW03_ShuiBeng", that.searchObj4).then((response) => {
                that.tableData4 = response.data.data.data;
                that.searchObj4.total = response.data.data.total;
            });
        },
        loadDetail4(row) {
            let that = this;
            that.visible4_detail = true;
            that.axios.post("YinErDa/Get_WXCW03_ShuiBeng_Log", { onlyInt: row.id }).then((response) => {
                that.tableData4_detail = response.data.data;
            });
        },
        loadMyCompanyDevice() {
            let that = this;
            that.axios
                .post("WXCW03/GetMyCompanyDevice1", {
                    deviceType: "WXCW81",
                })
                .then((response) => {
                    that.myCompanyDevice = response.data.data;
                });
        },
    },
    mounted() {
        let that = this;
        that.load4();
        that.loadMyCompanyDevice();
    },
};
</script>

<style>
.bgRed-WXCW03BJGL {
    background-color: #e6a23c !important;
}

.bgBlue-WXCW03BJGL {
    background-color: #409EFF !important;
}

.bgRed1-WXCW03BJGL {
    background-color: #F56C6C !important;
}
</style>